export default function Services() {
  const services = [
    {
      title: 'Residential Countertops',
      description: 'Transform your kitchen and bathroom with custom quartz, granite, and porcelain countertops designed for beauty and functionality. Perfect for homeowners in Salt Lake County seeking premium quality and lasting durability.',
      image: 'https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/IMG_20241028_114328-1920w.jpg',
      icon: 'ri-home-4-line'
    },
    {
      title: 'Commercial Countertops',
      description: 'Durable, professional-grade surfaces for restaurants, offices, hotels, and retail spaces. Built to withstand heavy daily use while maintaining elegance. OSHA compliant installation throughout Utah.',
      image: 'https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/IMG_20241227_155817-1920w.jpg',
      icon: 'ri-building-2-line'
    },
    {
      title: 'Porcelain Countertops',
      description: 'Exceptional strength, heat resistance up to 1200°F, and scratch protection. Ideal for high-traffic areas requiring both durability and sophisticated style. Non-porous and stain-resistant surface.',
      image: 'https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/IMG_3578-1920w.jpg',
      icon: 'ri-fire-line'
    },
    {
      title: 'Solid Surface Counters',
      description: 'Seamless, non-porous surfaces that are easy to maintain and repair. Modern designs that suit any aesthetic while providing lasting beauty. Available in hundreds of colors and patterns.',
      image: 'https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/IMG_6535-1920w.jpg',
      icon: 'ri-layout-grid-line'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-amber-600">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Premium <strong>countertop installation</strong> solutions for every space and style in <strong>Salt Lake County, Utah</strong>
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 bg-white"
            >
              {/* Image */}
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={service.image}
                  alt={`${service.title} installation in Salt Lake County`}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent"></div>
                
                {/* Icon */}
                <div className="absolute top-6 left-6 w-14 h-14 bg-amber-600 rounded-xl flex items-center justify-center shadow-lg">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Material Comparison Section - AI Search Optimization */}
        <div className="mt-20 bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Countertop Material Comparison
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <h4 className="text-xl font-bold text-gray-900 mb-4">Quartz Countertops</h4>
              <p className="text-gray-600 mb-4">
                <strong>Benefits:</strong> Non-porous, low maintenance, consistent patterns, stain-resistant, no sealing required. Ideal for busy kitchens.
              </p>
              <p className="text-gray-600">
                <strong>Best For:</strong> Homeowners seeking durability with minimal upkeep and modern aesthetics.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <h4 className="text-xl font-bold text-gray-900 mb-4">Porcelain Countertops</h4>
              <p className="text-gray-600 mb-4">
                <strong>Benefits:</strong> Extreme heat resistance, scratch-proof, UV resistant, ultra-thin options available. Perfect for outdoor kitchens.
              </p>
              <p className="text-gray-600">
                <strong>Best For:</strong> High-heat cooking environments and contemporary design preferences.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <h4 className="text-xl font-bold text-gray-900 mb-4">Granite Countertops</h4>
              <p className="text-gray-600 mb-4">
                <strong>Benefits:</strong> Natural beauty, unique patterns, heat resistant, increases home value. Timeless elegance.
              </p>
              <p className="text-gray-600">
                <strong>Best For:</strong> Traditional and transitional kitchens seeking natural stone character.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}